export class RegexProvider {

  public static htmlTags: RegExp = /<[^>]+>/g;

  public static email: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public static domain: RegExp = /^(([a-z0-9])([-]{0,1}))+$/;
  
  public static alpha: RegExp = /^[a-zA-Z ]+$/;
  public static numeric: RegExp = /^[0-9]+$/;
  public static alphaNumeric: RegExp = /^[a-zA-Z0-9 ]+$/;
  public static contactNumber: RegExp = /^[+0-9]+$/;
  public static accountNumber: RegExp = /^[0-9* ]+$/;
  public static referralCode: RegExp = /^[a-zA-Z!@#$%^&*-_=+.,0-9~]+$/;
  
  // Internalization compatible
  public static alphaI18n: RegExp = /^[a-zA-Z\s|\u00c0-\u01ff|\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3]+$/;
  public static alphaNumericI18n: RegExp = /^[a-zA-Z0-9\s|\u00c0-\u01ff|\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3]+$/;
  public static alphaNumericSpecialI18n: RegExp = /^[a-zA-Z0-9,.<>?/\\:;'"\{\}\[\]\-`~_=+!@#$%^&*\(\)\s|\u00c0-\u01ff|\u3131-\u314e|\u314f-\u3163|\uac00-\ud7a3]+$/;
}
